import { render, staticRenderFns } from "./ProgramadorSeleccioneSalon.vue?vue&type=template&id=bacda084&"
import script from "./ProgramadorSeleccioneSalon.vue?vue&type=script&lang=js&"
export * from "./ProgramadorSeleccioneSalon.vue?vue&type=script&lang=js&"
import style0 from "./ProgramadorSeleccioneSalon.vue?vue&type=style&index=0&id=bacda084&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports